// Rajesh 11/23/2022 2699234404 job executions table
// Rajesh 11/23/2022 2699234404 Worked on data pre-population
// Suresh Peddavoora 11/24/2022 2699234404 Added classname for Table Enhancements
// Suresh peddavoora 11/30/2022 2699234404 Added Class Name for Table Pagination Alignment Issue.
// rajesh 12/05/2022 2699234404 task execution table
// rajesh 12/16/2022  2699234404 added file name column
// akhila 12/27/2022 2699234404 fixed job execution start Time and End Time
// sai krisna 12/27/2022 2699234404 add download Icon for download recored
// kavyareddy 12/30/2022 2699234404 Added download button in job execution
// kavyareddy 01/03/2023 2699234404 Changed the action dispatch
// Ashraf 01/04/2023 2699234404 changed date format display
// Ashraf 01/04/2023 2700430604 fixed time format issue
// Akhila 01/24/2023 2700430604 Added custom table for No records
// Akhila 02/27/2023 2700430604 implemented preview file functionality in download configuration
// suresh peddavoora 03/06/2023 2700430604 new UI changes
// Akhila 03/10/2023 2700430604 Added preview toast message and loader
// Prakash 21/04/2023 2700430604 fixed button alignments issue
// Akhila 06/13/2023 3225736869 Added code and description

import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Button, makeStyles, Tooltip} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {
  resetJobExecution,
  fetchTaskExecution,
  resetTaskExecution,
  fetchJobExecution,
  postTaskDownload,
  postPrintSchedulerExecution,
} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import {ArrowBack} from '@material-ui/icons';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import {
  fetchDownloadSuccess,
} from '../../../../../redux/reducers/PreviewFileData';
import BreadCrums from '../../../../../util/BreadCrum';

const useStyles = makeStyles((theme) => ({
  'dialoguecardStyles': {
    'padding': '0px 15px',
    '& .MuiTypography-h4': {
      fontSize: '14px',
      fontFamily: 'articulat-cf, sans-serif !important',
    },
  },
  'goBackBtn': {
    padding: '6px 12px',
    color: '#320469',
    marginBottom: '10px',
  },
  'link': {
    color: '#320469 !important',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));
const JobExecution = ({
  open,
  dialogClose,
  title,
  maxWidth,
  value,
  handleSubmit,
  condition,
  buttonCondition,
  reportCodeData,
  executionRowData,
}) => {
  console.log(executionRowData, 'executionRowData');
  const classes = useStyles();
  const tableRef = createRef();
  const [jobCode, setJobCode] = useState();
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Job Name',
      field: 'jobCode',
      render: (rowData) => (
        <span
          style={{
            maxWidth: 165,
            textAlign: 'justify',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            borderBottom: '1px solid #000099',
            cursor: 'pointer',
          }}
          className={classes.link}
          onClick={() => {
            setJobCode(rowData?.jobCode);
            dispatch(resetJobExecution());
            dispatch(fetchTaskExecution(rowData?.jobExecutionId));
          }}
        >
          {rowData?.jobCode}
        </span>
      ),
    },
    {
      title: 'StartDate & Time ',
      field: 'startTime',
      render: (rowData) => {
        return rowData?.startTime ?
          moment(rowData?.startTime).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'EndDate & Time',
      field: 'endTime',
      render: (rowData) => {
        return rowData?.endTime ?
          moment(rowData?.endTime).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'Execution Status',
      field: 'execStatus',
      render: (rowData) => (
        <span style={{color: rowData.status === 'COMPLETED' ? '#00af00' : '#FA113D'}}>
          {rowData?.status ? rowData?.status : rowData?.execStatus ? rowData?.execStatus : ''}
        </span>
      ),
    },
    {
      title: 'Executed By',
      field: 'executedBy',
    },
    {
      title: 'Error Message',
      field: 'errorMessage',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.errorMessage?.split(',').join(', ')} interactive>
            <p className="popup-text">{rowData?.errorMessage?.split(',').join(', ')}</p>
          </Tooltip>
        );
      },
      // render: (rowData) => <span style={{ whiteSpace: "pre-wrap" }}>{rowData.errorMessage}</span>,
    },
  ];
  const columns1 = [
    {
      title: 'File Name',
      field: 'fileName',
      // render: (rowData) => (
      //   <span
      //     style={{
      //       maxWidth: 165,
      //       textAlign: "justify",
      //       whiteSpace: "normal",
      //       wordWrap: "break-word",
      //       borderBottom: "1px solid #000099",
      //       cursor: "pointer",
      //     }}
      //     className={classes.link}
      //     onClick={() => {
      //       dispatch(
      //         postTaskDownload({
      //           dockey: rowData?.docKey,
      //         })
      //       );
      //     }}
      //   >
      //     {rowData?.fileName}
      //   </span>
      // ),
    },
    {
      title: 'Task Code',
      field: 'taskCode',
    },
    {
      title: 'StartDate & Time ',
      field: 'startTime',
      render: (rowData) => {
        return rowData?.startTime ?
          moment(rowData?.startTime).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'EndDate & Time',
      field: 'endTime',
      render: (rowData) => {
        return rowData?.endTime ?
          moment(rowData?.endTime).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'Execution Status',
      field: 'execStatus',
      render: (rowData) => (
        <span style={{color: rowData.execStatus === 'COMPLETED' ? '#00af00' : '#FA113D'}}>
          {rowData?.execStatus ? rowData?.execStatus : ''}
        </span>
      ),
    },
    {
      title: 'Error Message',
      field: 'errorMessage',
      cellStyle: {
        minWidth: 250,
        maxWidth: 350,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      render: (rowData) => {
        return (
          <Tooltip title={rowData?.errorMessage?.split(',').join(', ')} interactive>
            <p className="popup-text">{rowData?.errorMessage?.split(',').join(', ')}</p>
          </Tooltip>
        );
      },
      // render: (rowData) => <span style={{ whiteSpace: "pre-wrap" }}>{rowData.errorMessage}</span>,
    },
  ];
  const dispatch = useDispatch();
  const [rows, setRows] = useState(defaultRows);

  const {nightJobExecutionData, nightTaskExecutionData} =
    useSelector(({addNightJob}) => addNightJob);
  const nightJobData =
    nightJobExecutionData?.length > 0 ?
      nightJobExecutionData?.map((item) => ({
        ...item,
      })) :
      [];
  const nightTaskData =
    nightTaskExecutionData?.length > 0 ?
      nightTaskExecutionData?.map((item) => ({
        ...item,
      })) :
      [];

  // const results =data?.length > 0 && data?.filter(element =>  Object.keys(element).length !== 0)
  // const nightJobData = results?.length > 0
  //   ? results?.map((ele, i) => ({
  //     ...ele[0],
  //   }))
  //   : [];
  useEffect(() => {
    return () => {
      dispatch(resetJobExecution());
    };
  }, []);
  useEffect(() => {
    return () => {
      dispatch(resetTaskExecution());
    };
  }, []);

  return (
    <div className={classes.dialoguecardStyles}>
      <BreadCrums
        name={'Name'}
        code={executionRowData?.jobCode}
        description={'Description'}
        descriptionValue={executionRowData?.jobDescription}
      />
      {nightJobExecutionData?.length > 0 ? (
        <div className="custom-table global-field-table new-standard-textfields popup-block">
          <GuiTable
            title=""
            columns={columns}
            // isLoading={nightJobExecutionData && isLoading}
            tableRef={tableRef}
            data={nightJobData}
            actions={[
              (rowData) => {
                if (rowData?.jobExecutionId) {
                  return {
                    icon: () => <GetAppOutlinedIcon />,
                    tooltip: 'Download',
                    onClick: (event, rowData) => {
                      dispatch(postPrintSchedulerExecution(rowData?.jobExecutionId));
                    },
                  };
                }
              },
            ]}
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: false,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      ) : nightTaskExecutionData?.length > 0 ? (
        <div className="custom-table global-field-table new-standard-textfields popup-block">
          <Button
            variant="text"
            className={`mb-3 search-btn`}
            onClick={() => {
              dispatch(fetchJobExecution(jobCode));
              dispatch(resetTaskExecution());
            }}
          >
            <ArrowBack className="mr-2" />
            Go Back
          </Button>
          <GuiTable
            title=""
            columns={columns1}
            // isLoading={nightTaskExecutionData && isLoading}
            tableRef={tableRef}
            data={nightTaskData}
            actions={[
              (rowData) => {
                if (rowData?.docKey) {
                  return {
                    icon: () => <GetAppOutlinedIcon />,
                    tooltip: 'Download',
                    onClick: (event, rowData) => {
                      dispatch(
                        postTaskDownload({
                          dockey: rowData?.docKey,
                        }),
                      );
                      dispatch(
                        fetchDownloadSuccess({
                          response: 'Scheduler Execution Downloaded SuccessFully',
                        }),
                      );
                    },
                  };
                }
              },
            ]}
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: false,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      ) : (
        <>
          <div
            className={
              'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields'
            }
          >
            <table>
              <thead className="recFormat-header-container">
                <tr>
                  <th className="recFormat-header">Action</th>
                  <th className="recFormat-header">Job Name</th>
                  <th className="recFormat-header">StartDate & Time</th>
                  <th className="recFormat-header">EndDate & Time</th>
                  <th className="recFormat-header">Execution Status</th>
                  <th className="recFormat-header">Error Message</th>
                </tr>
              </thead>
              <tbody className="recFormat-body">
                <tr>
                  <td colSpan={columns1.length}>No records to display.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default JobExecution;
